export default __webpack_public_path__ + "static/media/Feat2.4a72d6cd.jpeg";